// Cálculo do modal de item do PDV (Parâmetros → PDV → "Permitir desconto
// unitário"). O preço unitário é a base de tudo e tem 2 casas decimais
// (itens_venda.preco_unitario é NUMERIC(12,2)). Na NF-e/NFC-e o vProd precisa
// bater com vUnCom × qCom, então o total nunca é gravado solto: ele sai sempre
// de quantidade × preço unitário.
const arred = (v, casas = 2) => {
  const f = 10 ** casas;
  return Math.round((Number(v) + Number.EPSILON) * f) / f;
};

// Aceita "1.234,56", "1234,56" e "1234.56".
export function lerNumero(v) {
  const s = String(v ?? '').trim();
  if (!s) return 0;
  const limpo = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
  const n = parseFloat(limpo);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

// Preço unitário resultante de editar um campo. 'qtd' não muda o preço.
export function precoDoCampo(campo, valor, { bruto, qtd, unit }) {
  const n = lerNumero(valor);
  switch (campo) {
    case 'pct':   return arred(bruto * (1 - Math.min(n, 100) / 100));
    case 'descR': return qtd > 0 ? Math.max(0, arred((bruto * qtd - n) / qtd)) : unit;
    case 'unit':  return arred(n);
    case 'total': return qtd > 0 ? arred(n / qtd) : unit;
    default:      return unit;
  }
}

// Valores mostrados. Preço acima do bruto não aparece como acréscimo: o
// desconto fica zerado e só o preço e o total sobem.
export function calcularItem({ bruto, qtd, unit }) {
  const total = arred(qtd * unit);
  const abaixo = bruto > 0 && unit < bruto;
  return {
    unit,
    total,
    descR: abaixo ? arred(bruto * qtd - total) : 0,
    pct: abaixo ? arred((1 - unit / bruto) * 100, 5) : 0,
  };
}

// desconto_maximo_pct = 0 significa "sem limite" (mesma regra de vendasController).
export function precoMinimo(bruto, descontoMaximoPct) {
  const max = Number(descontoMaximoPct) || 0;
  return max > 0 ? arred(bruto * (1 - max / 100)) : null;
}

// Preço de tabela enviado na venda: com preço acima do bruto, vai igual ao
// preço cobrado para a venda não registrar desconto negativo no item.
export const precoTabelaDaVenda = item => {
  const tabela = item.preco_tabela ?? item.preco_unit;
  return item.preco_manual ? Math.max(tabela, item.preco_unit) : tabela;
};
